import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor(private router: Router) {
  }

  home(): void {
    this.navigate('home');
  }

  album(): void {
    this.navigate('album');
  }

  media(): void {
    this.navigate('media');
  }

  live(): void {
    this.navigate('live');
  }

  impressum(): void {
    this.navigate('impressum');
  }

  instagram(): void {

    this.goToLink('https://www.instagram.com/rooftopradioband/');
  }

  facebook(): void {

    this.goToLink('https://www.facebook.com/RooftopRadioBand');
  }

  youtube(): void {

    this.goToLink('https://www.youtube.com/watch?v=N8dZZkgUCmc');
  }

  spotify(): void {

    this.goToLink('https://open.spotify.com/album/6he0mtPRt7Tu1wPXQbRSVL?si=OMwByCSiTYe-yZUht8Vt0w&dl_branch=1');
  }

  bandcamp(): void {

    this.goToLink('https://rooftopradio.bandcamp.com/releases');
  }

  email(): void {

    this.goToLink('mailto:band@rooftopradio.de');
  }

  navigate(location: string): void {

    this.router.navigate([location]);
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }

}
